export const deleteOutdatedKeys = (keyPrefix: string) => {
  const len = localStorage.length;
  for (let i = 0; i < len; i++) {
    const keyName = localStorage.key(i) || '';
    if (keyName.includes(keyPrefix)) {
      localStorage.removeItem(keyName);
      continue;
    }
  }
};

export const setLocalStorageStatus = (keyPrefix: string, storageKey: string, storageValue: string) => {
  deleteOutdatedKeys(keyPrefix);
  window.localStorage.setItem(storageKey, storageValue);
};
